import React from 'react';
import { Link } from 'react-router-dom';
import BlogPreview from '../components/BlogPreview';
import Testimonials from '../components/Testimonials';
import YouTubeSection from '../components/YouTubeSection';
import InstagramSection from '../components/InstagramSection';
import { ROUTES, SERVICE_ROUTES } from '../data/siteLinks';

const HomePage: React.FC = () => {
  const serviceItems = [
    {
      title: 'Göç Öncesi Hazırlık',
      description:
        'Taşınma öncesi yapılacakların planlanmasına yönelik genel bilgiler ve deneyim paylaşımı.',
      path: SERVICE_ROUTES.migrationPreparation,
    },
    {
      title: 'Vize Süreçleri',
      description:
        'Blue Card, Fırsat Kartı, çalışma, iş arama, aile birleşimi ve öğrenci vizesi süreçlerine ilişkin genel bilgiler.',
      path: SERVICE_ROUTES.visa,
    },
    {
      title: 'Oturum Süreçleri',
      description:
        'Vizeden oturuma geçiş, oturum uzatma, iş değişikliği ve süresiz oturum süreçlerine ilişkin genel bilgiler.',
      path: SERVICE_ROUTES.residence,
    },
    {
      title: 'Üniversite',
      description: 'Üniversite seçimi, başvuru belgeleri, kayıt ve hazırlık süreçleri.',
      path: SERVICE_ROUTES.education,
    },
    {
      title: 'Dil Okulu',
      description: 'Dil okulu seçimi, kayıt belgeleri ve eğitim öncesi hazırlık süreci.',
      path: SERVICE_ROUTES.education,
    },
    {
      title: 'Kindergarten',
      description: 'Kindergarten, Tagesmutter ve okul seçenekleri ile kayıt süreçleri.',
      path: SERVICE_ROUTES.education,
    },
    {
      title: 'Ev Kiralama',
      description: 'Eşyalı veya boş daire arama, başvuru dosyası ve kiralama hazırlıkları.',
      path: SERVICE_ROUTES.housing,
    },
    {
      title: "Almanya'daki İlk İşlemler",
      description: 'Anmeldung, banka hesabı, sağlık sigortası ve yerleşim sonrası idari işlemler.',
      path: SERVICE_ROUTES.postMigration,
    },
    {
      title: 'Yeni Hayata Uyum',
      description: 'Telefon hattı, ulaşım, günlük yaşam, sosyal düzen ve entegrasyon kursları.',
      path: SERVICE_ROUTES.integration,
    },
  ];

  return (
    <div>
      {/* 1. Hero Section */}
      <section className="section-hero">
        <div className="container">
          <div className="hero-content">
            <h1>Almanya'ya Göç Yolculuğunuzda Yanınızdayız!</h1>
            <p>
              Almanya'ya taşınma sürecinde, ilk hazırlıklardan yeni düzeninizi kurmaya kadar
              edindiğimiz deneyimleri ve pratik bilgileri sizinle paylaşıyoruz.
            </p>
            <Link to={ROUTES.appointment} className="btn-teal">
              Randevu Alın
            </Link>
          </div>
          <div className="hero-image">
            <img
              src="/images/hero-graphic.png"
              alt="Almanya'ya Göç"
              fetchPriority="high"
              decoding="async"
            />
          </div>
        </div>
      </section>

      {/* 2. Ben Ayşegül Section */}
      <section className="section-teal">
        <div className="container">
          <div className="about-content">
            <h4>Ben Ayşegül,</h4>
            <p>
              2020 yılında ailemle birlikte İstanbul'dan Almanya'ya taşındım. Taşınma öncesinden
              yerleşim sonrasına kadar geçen sürede edindiğim bilgi ve deneyimler, zaman içerisinde
              benzer bir yolda ilerleyen birçok kişiye eşlik etmemi sağladı.
            </p>
            <p>
              Almanya'ya taşınmayı planlayan bireylerin ve ailelerin sürecin farklı aşamalarında
              karşılaşabilecekleri operasyonel süreçler hakkında, kendi deneyimlerime ve
              araştırmalarıma dayanan bilgileri paylaşıyorum.
            </p>
            <p>
              Taşınma sürecinin daha hazırlıklı ve anlaşılır ilerlemesi için idari süreçlere yönelik
              bir oryantasyon desteği sunuyorum. Hukuki analiz, danışmanlık ve temsil gerektiren tüm
              işlemler, hukuki ortağımız Avukat Dr. Hayrullah Özcan tarafından yürütülmektedir.
            </p>
            <Link to={ROUTES.about} className="btn-dark">
              Hakkımızda
            </Link>
          </div>
          <div className="about-image">
            <img
              src="/images/profile-photo.jpg"
              alt="Ayşegül Saraç"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </section>

      {/* 3. Hizmet Alanlarımız Section */}
      <section id="hizmetler" className="section-services">
        <div className="container">
          <h2>Hizmet Alanlarımız</h2>
          <p className="services-subtext">
            Almanya'ya taşınma hazırlığından yeni yaşamınızı kurmaya kadar ihtiyaç
            duyabileceğiniz konularda bilgi ve organizasyon desteği sunuyoruz.
          </p>
          <div className="services-grid-home">
            {serviceItems.map((service, index) => (
              <Link
                to={service.path}
                key={`${service.path}-${service.title}`}
                className={`service-item service-item-group-${Math.floor(index / 3) + 1}`}
              >
                <span className="service-item-title">{service.title}</span>
                <span className="service-item-description">{service.description}</span>
                <span className="service-item-link">
                  Hizmeti inceleyin
                </span>
              </Link>
            ))}
          </div>
          <Link to={`${ROUTES.services}#hizmet-ucretleri`} className="services-pricing-cta">
            Hizmetleri ve fiyatlarını inceleyin <span aria-hidden="true">→</span>
          </Link>
        </div>
      </section>

      {/* 4. Google Yorumları Section */}
      <Testimonials />

      {/* 5. Randevu Alın Section */}
      <section className="section-randevu">
        <div className="container">
          <div className="randevu-content">
            <h2>Randevu Alın</h2>
            <p>
              Hizmetlerimiz hakkında daha fazla bilgi almak ve hazırlık sürecine dair detayları
              öğrenmek için bizimle iletişime geçebilirsiniz. Sürece dair operasyonel sorularınızı
              yanıtlamak ve hazırlık aşamaları hakkında genel bir bilgilendirme görüşmesi için
              randevunuzu kolayca planlayabilirsiniz.
            </p>
            <Link to={ROUTES.appointment} className="btn-dark">
              Randevu Alın
            </Link>
          </div>
          <div className="randevu-image">
            <img
              src="/images/randevu.png"
              alt="Randevu"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </section>

      {/* 6. Son Yazılar Section */}
      <section className="section-blog-preview">
        <BlogPreview />
      </section>

      {/* 7. Ayşegül YouTube'da Section - white bg */}
      <YouTubeSection />

      {/* 8. Ayşegül Instagram'da Section */}
      <InstagramSection />
    </div>
  );
};

export default HomePage;
